import './PrivecyCode.css';

import React, { useEffect, useState, useRef } from "react";
import config from "../config.json";
import http from "../Services/httpService";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import services from "../Services/services";
import { toast } from "react-toastify";
import loginLogo from '../Images/logoWeb.png';

export default function PrivecyCode() {
    const location = useLocation();
    const navigate = useNavigate();

    const [progress, setProgress] = useState(false);
    const [progress2, setProgress2] = useState(false);
    
    // دریافت شماره و کدملی از state ناوبری
    const [mobileNumber] = useState(location.state?.mobile || "");
    const [codeMeli] = useState(location.state?.codeMeli || location.state?.coeMeli || "");

    const INITIAL_SECONDS = 120; // ۲ دقیقه
    const [seconds, setSeconds] = useState(INITIAL_SECONDS);
    const [form, setForm] = useState({ input1: "", input2: "", input3: "", input4: "" });

    const input1 = useRef(null);
    const input2 = useRef(null);
    const input3 = useRef(null);
    const input4 = useRef(null);
    const timerRef = useRef(null);

    // بررسی ورود مستقیم بدون شماره
    useEffect(() => {
        if (!mobileNumber) {
            navigate('/login');
        }
    }, [mobileNumber, navigate]);

    // شمارنده معکوس زمان
    useEffect(() => {
        timerRef.current = setInterval(() => {
            setSeconds(prev => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, []);

    // قالب‌بندی زمان به صورت دو رقمی 01:59
    const formatTime = (secs) => {
        const m = Math.floor(secs / 60);
        const s = secs % 60;
        return `${m < 10 ? '0' : ''}${m}:${s < 10 ? '0' : ''}${s}`;
    };

    // ثبت رقم و فوکوس به ورودی بعدی
    const handleChangeInput = (e) => {
        const { value, id } = e.target;
        const char = value.replace(/[^0-9]/g, '').slice(-1);

        setForm(prev => ({ ...prev, [id]: char }));

        if (char) {
            if (id === "input1") input2.current?.focus();
            else if (id === "input2") input3.current?.focus();
            else if (id === "input3") input4.current?.focus();
        }
    };

    // بازگشت فوکوس هنگام زدن کلید پاک کردن (Backspace)
    const handleKeyDown = (e, prevRef) => {
        if (e.key === 'Backspace' && !e.target.value && prevRef) {
            prevRef.current?.focus();
        }
    };

    // پشتیبانی هوشمند از چسباندن (Paste) کد ارسالی
    const handlePaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData('text').trim().replace(/[^0-9]/g, '');
        if (pasted.length >= 4) {
            setForm({
                input1: pasted[0],
                input2: pasted[1],
                input3: pasted[2],
                input4: pasted[3]
            });
            input4.current?.focus();
        }
    };

    // ارسال مجدد پیامک
    const resend = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!mobileNumber) {
            navigate('/login');
            return;
        }

        setProgress2(true);
        try {
            const { data } = await services.RequestVerifyCode(mobileNumber, codeMeli);
            setProgress2(false);
            if (data.errorCode !== 0) {
                toast.error(data.message, { theme: "colored" });
                return;
            }
            toast.dark('پیامک جدید برای شما ارسال گردید');
            setSeconds(INITIAL_SECONDS);

            if (timerRef.current) clearInterval(timerRef.current);
            timerRef.current = setInterval(() => {
                setSeconds(prev => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        } catch (err) {
            setProgress2(false);
        }
    };

    // تایید و ارسال نهایی لاگین
    const handleAdd = async (e) => {
        e.preventDefault();
        const code = `${form.input1}${form.input2}${form.input3}${form.input4}`;

        if (code.length < 4) {
            toast.error('لطفاً کد تایید ۴ رقمی را کامل وارد فرمایید', { theme: "colored" });
            return;
        }

        setProgress(true);
        try {
            const { data } = await services.login({
                mobile: mobileNumber,
                codeMeli: codeMeli,
                code: code,
                verision: config?.Version,
                version: `${config?.version || config?.Version}`,
                Company: config?.Company,
                Year: config?.Year
            });
            
            setProgress(false);
            if (data.errorCode !== 0) {
                toast.error(data.message, { theme: "colored" });
                return;
            }

            http.setLocalJwt(data.payload.access_token);
            navigate('/main');
        } catch (err) {
            setProgress(false);
        }
    };

    return (
        <div className="container-fluid bg-light min-vh-100 d-flex align-items-center justify-content-center p-3" dir="rtl">
            <div className="card shadow border-0 rounded-4 p-4 p-sm-5 bg-white text-center w-100" style={{ maxWidth: '440px' }}>

                {/* لوگو و عنوان */}
                <div className="mb-4">
                    <img 
                        src={loginLogo} 
                        className="img-fluid mb-3" 
                        alt="لوگو" 
                        style={{ maxHeight: '80px', objectFit: 'contain' }}
                    />
                    <h1 className="h5 fw-bold text-dark mb-1">
                        <span className="me-2" aria-hidden="true">📩</span>
                        تایید شماره همراه
                    </h1>
                    <p className="text-secondary small mt-2 mb-0">
                        کد تایید ۴ رقمی ارسال‌شده به شماره زیر را وارد نمایید:
                    </p>
                    {mobileNumber && (
                        <div className="fw-bold text-primary mt-2 dir-ltr user-select-all font-monospace fs-5">
                            {mobileNumber}
                        </div>
                    )}
                </div>

                {/* فیلدهای OTP */}
                <form onSubmit={handleAdd}>
                    <div className="d-flex justify-content-center gap-2 gap-sm-3 my-4" dir="ltr">
                        <input
                            ref={input1}
                            id="input1"
                            type="text"
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            pattern="[0-9]*"
                            maxLength="1"
                            value={form.input1}
                            onChange={handleChangeInput}
                            onPaste={handlePaste}
                            autoFocus
                            className="form-control text-center fw-bold fs-3 rounded-3 shadow-sm"
                            style={{ width: '56px', height: '62px' }}
                        />
                        <input
                            ref={input2}
                            id="input2"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength="1"
                            value={form.input2}
                            onChange={handleChangeInput}
                            onKeyDown={(e) => handleKeyDown(e, input1)}
                            onPaste={handlePaste}
                            className="form-control text-center fw-bold fs-3 rounded-3 shadow-sm"
                            style={{ width: '56px', height: '62px' }}
                        />
                        <input
                            ref={input3}
                            id="input3"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength="1"
                            value={form.input3}
                            onChange={handleChangeInput}
                            onKeyDown={(e) => handleKeyDown(e, input2)}
                            onPaste={handlePaste}
                            className="form-control text-center fw-bold fs-3 rounded-3 shadow-sm"
                            style={{ width: '56px', height: '62px' }}
                        />
                        <input
                            ref={input4}
                            id="input4"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength="1"
                            value={form.input4}
                            onChange={handleChangeInput}
                            onKeyDown={(e) => handleKeyDown(e, input3)}
                            onPaste={handlePaste}
                            className="form-control text-center fw-bold fs-3 rounded-3 shadow-sm"
                            style={{ width: '56px', height: '62px' }}
                        />
                    </div>

                    {/* تایمر معکوس / ارسال مجدد */}
                    <div className="mb-4">
                        {seconds > 0 ? (
                            <div className="d-flex align-items-center justify-content-center gap-2 text-secondary small bg-light py-2 px-3 rounded-pill border">
                                <span aria-hidden="true">⏳</span>
                                <span>زمان باقی‌مانده تا ارسال مجدد:</span>
                                <span className="fw-bold text-dark font-monospace dir-ltr">{formatTime(seconds)}</span>
                            </div>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm px-3 py-2 rounded-pill fw-bold d-inline-flex align-items-center gap-1 shadow-sm"
                                onClick={resend}
                                disabled={progress2}
                            >
                                <span aria-hidden="true">🔄</span>
                                <span>ارسال مجدد پیامک کد</span>
                                {progress2 && (
                                    <div className="spinner-border spinner-border-sm text-primary ms-1" role="status">
                                        <span className="visually-hidden">در حال ارسال...</span>
                                    </div>
                                )}
                            </button>
                        )}
                    </div>

                    {/* دکمه ارسال */}
                    <button
                        type="submit"
                        className="btn btn-primary w-100 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2 shadow-sm"
                        disabled={progress}
                    >
                        {progress ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span>در حال تایید کد...</span>
                            </>
                        ) : (
                            <>
                                <span className="fw-bold">تایید و ورود</span>
                                <span aria-hidden="true">➜</span>
                            </>
                        )}
                    </button>
                </form>

                {/* لینک تغییر شماره و بازگشت */}
                <div className="mt-4 pt-3 border-top">
                    <Link to="/login" className="btn btn-light btn-sm text-secondary rounded-pill d-inline-flex align-items-center gap-1 text-decoration-none px-3 py-2 border">
                        <span aria-hidden="true">✏️</span>
                        <span>ویرایش شماره موبایل / ورود مجدد</span>
                    </Link>
                </div>

                {/* فوتر نگارش */}
                {(config?.Company || config?.Version) && (
                    <div className="text-center text-muted small opacity-75 mt-3 pt-1">
                        <span>{config?.Company}</span>
                        {config?.Version && <span className="mx-1">• نسخه {config?.Version}</span>}
                    </div>
                )}
            </div>
        </div>
    );
}
